<template>
  <div class="mr-auto">
    <eg-b-spinner
      v-if="initialLoading"
      :label="$t('essays.checkingUnreviewed')"
    />
    <span v-if="unreviewedEssaysCount" class="flex-grow-1">
      <eg-b-icon style="color: #ffc107" icon="exclamation-triangle" />
      {{ $t("essays.unreviewedCount", { count: unreviewedEssaysCount }) }}
      <eg-b-link to="#" @click="redirectToEssays">
        {{ $t("essays.reviewLink") }}
      </eg-b-link>
    </span>
  </div>
</template>

<script>
import fetchEssays from "@/mixins/fetchEssays";
import {
  generateFilterName,
  setFiltersToLocalStorage,
} from "@/utils/localStorage";

export default {
  name: "UnreviewedAlert",

  // this.defaultFilters
  // this.fetchEssays()
  // this.count
  mixins: [fetchEssays],

  computed: {
    unreviewedEssaysCount() {
      return this.count;
    },
  },

  created() {
    this.fetchEssays({
      filters: {
        status: "Graded",
        folderId: this.$route.params.id,
      },
    });
  },

  methods: {
    redirectToEssays() {
      this.$emit("close");

      const filterName = generateFilterName({
        entity: "assignments",
        id: this.$route.params.id,
      });
      setFiltersToLocalStorage(filterName, { reviewStatus: "Graded" });

      this.$router.push({
        name: "workspace",
        params: {
          workspaceKey: this.$route.params.workspaceKey,
          id: this.$route.params.id,
        },
      });
    },
  },
};
</script>
